import { render, staticRenderFns } from "./journalism.vue?vue&type=template&id=7a66c584&scoped=true"
import script from "./journalism.vue?vue&type=script&lang=js"
export * from "./journalism.vue?vue&type=script&lang=js"
import style0 from "./journalism.vue?vue&type=style&index=0&id=7a66c584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a66c584",
  null
  
)

export default component.exports